import React from 'react';
import {
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack
} from "@chakra-ui/react";
import { Link } from 'react-router-dom';
import UserAvatar from "../utils/avatars/UserAvatar";
import ResourceProgress from "../utils/ResourceProgress";
import useTranslations from '../../hooks/useTranslations';

export type UserListModalProps = {
  users: { id: string, avatar?: string, name: string }[],
  onClose: () => void,
  isOpen: boolean,
  label?: string,
  loading?: boolean,
}

const UserListModal: React.FC<UserListModalProps> = ({
  users,
  onClose,
  isOpen,
  label,
  loading = false
}) => {
  const t = useTranslations();

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{label || t("screens.dashboard.searchResultsCount", { count: users.length })}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <ResourceProgress
            isLoading={loading}
            isEmpty={users.length === 0}
            emptyMessage={t("statistics.notEnoughData") as string}
            padding={4}
          />
          <VStack
            align="flex-start"
          >
            {
              users.map((user) => (
                <Link 
                  key={user.id} 
                  to={`/users/${user.id}`}
                >
                  <HStack>
                    <UserAvatar
                      src={user.avatar}
                      alt={user.name}
                      size={8}
                    />
                    <span>{user.name}</span>
                  </HStack>
                </Link>
              ))
            }
           </VStack>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>{t("forms.actions.close")}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default React.memo(UserListModal);
